import React from 'react';
import {
  Box, FormControl, InputLabel, Select, MenuItem, FormGroup, FormControlLabel, Checkbox, TextField, Typography,
} from '@mui/material';
import { TSHIRT_SIZES, DIETARY_OPTIONS } from './participantOptions';

// The dietary field is stored as one string, the same as the dancer/staff
// forms: chosen tags joined with ", ", with "Other: <text>" last.
export function parseDietary(value) {
  const s = String(value || '');
  const otherAt = s.indexOf('Other');
  const tagsPart = otherAt === -1 ? s : s.slice(0, otherAt);
  const tags = tagsPart.split(',').map(t => t.trim()).filter(t => DIETARY_OPTIONS.includes(t));
  if (otherAt !== -1) tags.push('Other');
  const otherText = otherAt === -1 ? '' : s.slice(otherAt + 'Other'.length).replace(/^:\s*/, '').trim();
  return { tags, otherText };
}

export function formatDietary(tags, otherText) {
  return tags.map(t => (t === 'Other' && otherText.trim() ? `Other: ${otherText.trim()}` : t)).join(', ');
}

// T-shirt size + dietary checkboxes — used on the admin leader dialog and the
// leader's own link. value: { tshirtSize, dietary }; onChange(partial).
export default function SizeDietaryFields({ value, onChange, disabled = false }) {
  const { tags, otherText } = parseDietary(value.dietary);
  const setDietary = (nextTags, nextOther = otherText) => onChange({ dietary: formatDietary(nextTags, nextOther) });
  const toggle = (option) => {
    if (option === 'None') return setDietary(tags.includes('None') ? [] : ['None'], '');
    const without = tags.filter(t => t !== 'None' && t !== option);
    return setDietary(tags.includes(option) ? without : [...without, option]);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <FormControl size="small" sx={{ maxWidth: 240 }} disabled={disabled}>
        <InputLabel>T-shirt size</InputLabel>
        <Select label="T-shirt size" value={TSHIRT_SIZES.includes(value.tshirtSize) ? value.tshirtSize : ''} onChange={e => onChange({ tshirtSize: e.target.value })}>
          <MenuItem value=""><em>Not chosen</em></MenuItem>
          {TSHIRT_SIZES.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}
        </Select>
      </FormControl>
      <Box>
        <Typography variant="body2" color="text.secondary">Dietary requirements and allergies</Typography>
        <FormGroup row>
          {DIETARY_OPTIONS.map(option => (
            <FormControlLabel key={option} disabled={disabled}
              control={<Checkbox size="small" checked={tags.includes(option)} onChange={() => toggle(option)} />}
              label={<Typography variant="body2">{option}</Typography>} />
          ))}
        </FormGroup>
        {tags.includes('Other') && (
          <TextField size="small" fullWidth label="Please describe" value={otherText} disabled={disabled}
            inputProps={{ maxLength: 300 }} onChange={e => setDietary(tags, e.target.value)} sx={{ mt: 0.5 }} />
        )}
      </Box>
    </Box>
  );
}
